import React from "react";
import { motion } from "framer-motion";


const FollowUs = () => {
    const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.5, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.6, ease: "easeOut" },
  },
};

const fadeDown = {
  hidden: { opacity: 0, y: -80 }, 
  visible: {
    opacity: 1,
    y: 0, 
    transition: { duration: 1.9, ease: "easeOut" },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.6,
      ease: "easeOut",
    },
  },
};



  return (
    <div className="relative flex items-start justify-center h-[500px] bg-gray-200 p-4 pt-16 mt-10">
        <div className='hidden md:block'>
           {/* <div className="absolute w-36 h-64 left-[12%] top-[10%] rounded-2xl overflow-hidden shadow-2xl">
           <img
              src="./assets/Follow1.png"
              alt=""
              className="w-full h-full object-cover"
              />
              </div> */}
            {/* <a
                href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="absolute w-36 h-64 left-[12%] top-[10%]
                rounded-2xl overflow-hidden shadow-2xl"
            >
            <img
                src="./assets/Follow1.png"
                alt="Instagram"
                className="w-full h-full object-cover cursor-pointer"
            />
            </a> */}
            <motion.a
                href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="absolute w-36 h-64 left-[12%] top-[10%] rounded-2xl overflow-hidden shadow-2xl"
                variants={fadeDown}       
                initial="hidden"          
                whileInView="visible"     
                viewport={{ once: true }} 
                >
                <img
                    src="./assets/Follow1.png"
                    alt="Instagram"
                    className="w-full h-full object-cover cursor-pointer"
                />
            </motion.a>

            <motion.a                
                    href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    rel="noopener noreferrer" 
                    className="absolute w-44 h-32 left-[6%]  bottom-[25%] 
                    z-20 rounded-2xl overflow-hidden shadow-2xl"
                    variants={fadeLeft}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
            >
            <img
                src="./assets/Follow5.png"
                alt="img"
                className="w-full h-full object-cover"
            />
            </motion.a>

            <motion.a
               href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
               target="_blank"
               rel="noopener noreferrer"    
               className="absolute w-40 h-40 left-[13%] top-[68%] 
               z-10 rounded-2xl overflow-hidden  shadow-2xl"
               variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}>
            <img
                src="./assets/Follow2.png"
                alt="img"
                className="w-full h-full object-cover"
            />
            </motion.a>

            <motion.a
              href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              className="absolute w-44 h-[300px] right-[8%] -top-7 
              rounded-2xl overflow-hidden  shadow-2xl"
              variants={fadeDown}       
              initial="hidden"          
              whileInView="visible"     
              viewport={{ once: true }}>
            <img
                src="./assets/Follow3.png"
                alt="img"
                className="w-full h-full object-cover"
            />
            </motion.a>

            <motion.a
               href="https://www.instagram.com/open.studios.co?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
               target="_blank"
               rel="noopener noreferrer" 
               className="absolute w-24 h-32 right-[5%] bottom-[30%] 
               rounded-2xl overflow-hidden  shadow-2xl"
               variants={fadeRight}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}>
            <img
               src="./assets/Follow7.png"
               alt="img"
               className="w-full h-full object-cover"
            />
            </motion.a>
        </div>

            {/* <div className="relative z-30 text-center">
            <h1 className="xl:text-9xl lg:text-8xl text-7xl leading-[0.85] text-black uppercase tracking-wide heading">
                   Follow us on<br className='hidden md:block'/>{" "}Social Media
            </h1>
            </div> */}
            {/* <motion.div
                initial={{ opacity: 0, scale: 0.7 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative z-30 text-center"
                > */}

                {/* <h1 className="xl:text-9xl lg:text-8xl text-7xl leading-[0.85] text-black uppercase tracking-wide heading">
                    Follow us on
                    <br className="hidden md:block" />{" "}
                    Social Media
                </h1> */}
                <h1 className="
                    xl:text-9xl lg:text-8xl text-7xl leading-[0.85] text-black uppercase tracking-wide heading text-center md:text-left">
                    Follow us on
                    <br className="hidden md:block" />{" "}
                    Social Media
                </h1>

            {/* </motion.div> */}

            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-40">
            <div className="flex flex-wrap justify-center gap-6">
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-[15px] mt-[5%] lg:mt-[2%]'>
                                {/* <button className="instagram_btn">
                                    <span className="instagram_icon">
                                        <svg height="2em" viewBox="0 0 128 128" width="2em" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <linearGradient id="a" gradientTransform="matrix(1 0 0 -1 594 633)" gradientUnits="userSpaceOnUse" x1="-566.711" x2="-493.288" y1="516.569" y2="621.43">
                                                <stop offset="0" stopColor="#ffb900" />
                                                <stop offset="1" stopColor="#9100eb" />
                                            </linearGradient>
                                            <circle cx="64" cy="64" fill="url(#a)" r="64" />
                                            <g fill="#fff">
                                                <path d="m82.333 104h-36.666c-11.947 0-21.667-9.719-21.667-21.667v-36.666c0-11.948 9.72-21.667 21.667-21.667h36.666c11.948 0 21.667 9.719 21.667 21.667v36.667c0 11.947-9.719 21.666-21.667 21.666zm-36.666-73.333c-8.271 0-15 6.729-15 15v36.667c0 8.271 6.729 15 15 15h36.666c8.271 0 15-6.729 15-15v-36.667c0-8.271-6.729-15-15-15z" />
                                                <path d="m64 84c-11.028 0-20-8.973-20-20 0-11.029 8.972-20 20-20s20 8.971 20 20c0 11.027-8.972 20-20 20zm0-33.333c-7.352 0-13.333 5.981-13.333 13.333 0 7.353 5.981 13.333 13.333 13.333s13.333-5.98 13.333-13.333c0-7.352-5.98-13.333-13.333-13.333z" />
                                                <circle cx="85.25" cy="42.75" r="4.583" />
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="instagram_text1">openstudiosco.</span>
                                    <span className="instagram_text2">Instagram</span>
                                </button> */}
            <a
              href="https://www.instagram.com/open.studios.co/"
              target="_blank"
              rel="noopener noreferrer" 
              className="instagram_btn"   
            > 
            <span className="instagram_icon">
            <svg height="2em" viewBox="0 0 128 128" width="2em" xmlns="http://www.w3.org/2000/svg">
                <linearGradient id="a" gradientTransform="matrix(1 0 0 -1 594 633)" gradientUnits="userSpaceOnUse" x1="-566.711" x2="-493.288" y1="516.569" y2="621.43">
                <stop offset="0" stopColor="#ffb900" />
                <stop offset="1" stopColor="#9100eb" />
                </linearGradient>
                <circle cx="64" cy="64" fill="url(#a)" r="64" />
                <g fill="#fff">
                <path d="m82.333 104h-36.666c-11.947 0-21.667-9.719-21.667-21.667v-36.666c0-11.948 9.72-21.667 21.667-21.667h36.666c11.948 0 21.667 9.719 21.667 21.667v36.667c0 11.947-9.719 21.666-21.667 21.666zm-36.666-73.333c-8.271 0-15 6.729-15 15v36.667c0 8.271 6.729 15 15 15h36.666c8.271 0 15-6.729 15-15v-36.667c0-8.271-6.729-15-15-15z" />
                <path d="m64 84c-11.028 0-20-8.973-20-20 0-11.029 8.972-20 20-20s20 8.971 20 20c0 11.027-8.972 20-20 20zm0-33.333c-7.352 0-13.333 5.981-13.333 13.333 0 7.353 5.981 13.333 13.333 13.333s13.333-5.98 13.333-13.333c0-7.352-5.98-13.333-13.333-13.333z" />
                <circle cx="85.25" cy="42.75" r="4.583" />
                </g>
            </svg>
            </span>

            <span className="instagram_text1">openstudiosco.</span>
            <span className="instagram_text2">Instagram</span>
            </a>
 
            <a
                href="https://www.linkedin.com/company/open-studioss/"  
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin_btn"
            >
            <span className="linkedin_icon">
            <svg fill="none" height="2em" viewBox="0 0 120 120" width="2em" xmlns="http://www.w3.org/2000/svg">
            <g clipRule="evenodd" fillRule="evenodd">
            <path d="m120 60.0002c0 33.1366-26.8633 59.9998-60 59.9998-33.138 0-60-26.8632-60-59.9998 0-33.1376 26.8617-60.0002 60-60.0002 33.1364.00031715 60 26.8626 60 60.0002z" fill="#0077B5" />
            <g fill="#fff">
            <path d="m63.8771 54.3451c.2959-.3181.411-.4154.4938-.5356 4.0325-5.884 9.7919-7.6141 16.5119-6.5811 7.7657 1.1953 12.7354 6.6312 14.004 14.949.3009 1.9723.4506 3.9525.449 5.9464-.0047 8.2817-.0177 16.563.0178 24.844.0054.9327-.2242 1.2067-1.1801 1.195-4.3386-.052-8.6787-.0514-13.0179 0-.9493.0104-1.1925-.2601-1.1874-1.1944.0352-7.7238.0228-15.4472.0152-23.1703-.0029-1.7554-.1234-3.4997-.6169-5.1996-1.5816-5.4524-7.7846-7.3664-12.2018-3.7408-2.3866 1.9581-3.3196 4.5473-3.3015 7.5947.0386 7.2858.0114 14.5713.0114 21.8571 0 .9558-.0533 1.9146.0162 2.8647.0608.8259-.2766.9848-1.0248.98-4.4194-.0298-8.8379-.033-13.2567.0019-.8017.0063-1.09-.1567-1.0808-1.038.0647-6.5672.091-13.1375.0939-19.7052.0012-8.0822-.0149-16.1637-.0714-24.2455-.006-.8848.1792-1.1465 1.0932-1.1363 4.4194.0495 8.8383.0422 13.2571.0051.7957-.0073 1.0177.2321.9923 1.0063-.0549 1.6656-.0165 3.3335-.0165 5.3026z" />
            <path d="m40.1241 71.1028c0 7.2826-.0155 14.5659.0187 21.8491.0038.9045-.1785 1.2264-1.1645 1.2134-4.377-.0584-8.7549-.0447-13.1324-.0079-.8129.0066-1.0869-.1963-1.086-1.0507.0213-14.6861.0178-29.3712-.0041-44.0569-.0009-.765.1856-1.0209.9882-1.0133 4.4579.038 8.9154.0428 13.3722-.0032.8896-.0098 1.0279.3149 1.0244 1.1008-.027 7.3235-.0152 14.6458-.0165 21.9687z" />
            <path d="m32.5678 25.8388c5.8726.0064 9.6878 4.6579 8.2959 10.1135-1.0517 4.1194-5.3122 6.491-10.2299 5.6924-5.2234-.8477-8.1348-5.9452-6.21-10.8714 1.2013-3.0767 4.2757-4.9392 8.144-4.9345z" />
            </g>
            </g>
            </svg>
            </span>

            <span className="linkedin_text1">openstudios</span>
            <span className="linkedin_text2">LinkedIn</span>
            </a>

            {/* <button className="facebook_btn">
                <span className="facebook_icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
                <g fillRule="evenodd" clipRule="evenodd">
                <path fill="#3a5ba2" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
                <path fill="#fff" d="m224.023 160.085c0-35.372 28.575-63.946 63.938-63.946h48.072v63.946h-32.199c-8.608 0-15.873 7.257-15.873 15.873v32.192h48.072v63.938h-48.072v144.22h-63.938v-144.22h-48.065v-63.938h48.065z"></path>
            </g>
            </svg>
            </span>
            <span className="facebook_text1">openstudios</span>
            <span className="facebook_text2">Facebook</span>
            </button> */}

            {/* <button className="whatsapp_btn">
            <span className="whatsapp_icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
            <g fillRule="evenodd" clipRule="evenodd">
            <path fill="#25D366" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
            <path fill="#fff" transform="translate(80, 60) scale(0.75)" d="M391.84 322.51l-85.1-6.5a39.78 39.78 0 0 0-45.15 8.4l-32.91 33.06a317.26 317.26 0 0 1-137.64-137.5l33.13-32.85a39.78 39.78 0 0 0 8.47-45.16l-36.51-85.08a39.87 39.87 0 0 0-45.15-23.16L48.58 10.96a39.84 39.84 0 0 0-38.38 39.94c0 234.88 190.5 425.44 425.42 425.44a39.84 39.84 0 0 0 0 39.88 0 0 0-23.16-45.22z"></path>
            </g>
            </svg>
            </span>
            <span className="extraFont whatsapp_text1">+91 9876543210</span>
            <span className="whatsapp_text2">WhatsApp</span>
            </button> */}
            <a
                href="https://wa.me/919664570369"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button className="whatsapp_btn">
                    <span className="whatsapp_icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 512 512">
                        <g fillRule="evenodd" clipRule="evenodd">
                        <path fill="#25D366" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z" />
                        <path
                            fill="#fff"
                            transform="translate(80, 60) scale(0.75)"
                            d="M391.84 322.51l-85.1-6.5a39.78 39.78 0 0 0-45.15 8.4l-32.91 33.06a317.26 317.26 0 0 1-137.64-137.5l33.13-32.85a39.78 39.78 0 0 0 8.47-45.16l-36.51-85.08a39.87 39.87 0 0 0-45.15-23.16L48.58 10.96a39.84 39.84 0 0 0-38.38 39.94c0 234.88 190.5 425.44 425.42 425.44a39.84 39.84 0 0 0 39.88-39.88 39.84 39.84 0 0 0-23.16-45.22z"
                        />
                        </g>
                    </svg>
                    </span>

                    <span className="extraFont whatsapp_text1">+91 9664570369</span>
                    <span className="whatsapp_text2">WhatsApp</span>   
                </button>  
                </a>

                </div>
                </div>
                </div>
                       
                        {/* <div className="flex items-center gap-2">
                            <div className="w-6 h-6 rounded-md bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] flex items-center justify-center">
                            <div className="w-4 h-4 border-2 border-white rounded-sm relative">
                                <div className="absolute top-0.5 right-0.5 w-0.5 h-0.5 bg-white rounded-full"></div>
                            </div>
                            </div>
                            <span className="text-gray-800 font-medium text-lg">openstudiosco.</span>
                        </div>

                        <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-[#0077b5] rounded-md flex items-center justify-center">
                            <span className="text-white text-[10px] font-bold">in</span>
                            </div>
                            <span className="text-gray-800 font-medium text-lg">openstudios</span>
                        </div> */}
                        
                        {/* <div className='grid grid-cols-1 lg:grid-cols-2 gap-[15px] mt-[5%] lg:mt-[2%]'>
                                <button className="instagram_btn">
                                    <span className="instagram_icon">
                                        <svg height="2em" viewBox="0 0 128 128" width="2em" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <linearGradient id="a" gradientTransform="matrix(1 0 0 -1 594 633)" gradientUnits="userSpaceOnUse" x1="-566.711" x2="-493.288" y1="516.569" y2="621.43">
                                                <stop offset="0" stopColor="#ffb900" />
                                                <stop offset="1" stopColor="#9100eb" />
                                            </linearGradient>
                                            <circle cx="64" cy="64" fill="url(#a)" r="64" />
                                            <g fill="#fff">
                                                <path d="m82.333 104h-36.666c-11.947 0-21.667-9.719-21.667-21.667v-36.666c0-11.948 9.72-21.667 21.667-21.667h36.666c11.948 0 21.667 9.719 21.667 21.667v36.667c0 11.947-9.719 21.666-21.667 21.666zm-36.666-73.333c-8.271 0-15 6.729-15 15v36.667c0 8.271 6.729 15 15 15h36.666c8.271 0 15-6.729 15-15v-36.667c0-8.271-6.729-15-15-15z" />
                                                <path d="m64 84c-11.028 0-20-8.973-20-20 0-11.029 8.972-20 20-20s20 8.971 20 20c0 11.027-8.972 20-20 20zm0-33.333c-7.352 0-13.333 5.981-13.333 13.333 0 7.353 5.981 13.333 13.333 13.333s13.333-5.98 13.333-13.333c0-7.352-5.98-13.333-13.333-13.333z" />
                                                <circle cx="85.25" cy="42.75" r="4.583" />
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="instagram_text1">openstudiosco.</span>
                                    <span className="instagram_text2">Instagram</span>
                                </button>

                                <button className="linkedin_btn">
                                    <span className="linkedin_icon">
                                        <svg fill="none" height="2em" viewBox="0 0 120 120" width="2em" xmlns="http://www.w3.org/2000/svg">
                                            <g clipRule="evenodd" fillRule="evenodd">
                                                <path d="m120 60.0002c0 33.1366-26.8633 59.9998-60 59.9998-33.138 0-60-26.8632-60-59.9998 0-33.1376 26.8617-60.0002 60-60.0002 33.1364.00031715 60 26.8626 60 60.0002z" fill="#0077B5"></path>
                                                <g fill="#fff">
                                                    <path d="m63.8771 54.3451c.2959-.3181.411-.4154.4938-.5356 4.0325-5.884 9.7919-7.6141 16.5119-6.5811 7.7657 1.1953 12.7354 6.6312 14.004 14.949.3009 1.9723.4506 3.9525.449 5.9464-.0047 8.2817-.0177 16.563.0178 24.844.0054.9327-.2242 1.2067-1.1801 1.195-4.3386-.052-8.6787-.0514-13.0179 0-.9493.0104-1.1925-.2601-1.1874-1.1944.0352-7.7238.0228-15.4472.0152-23.1703-.0029-1.7554-.1234-3.4997-.6169-5.1996-1.5816-5.4524-7.7846-7.3664-12.2018-3.7408-2.3866 1.9581-3.3196 4.5473-3.3015 7.5947.0386 7.2858.0114 14.5713.0114 21.8571 0 .9558-.0533 1.9146.0162 2.8647.0608.8259-.2766.9848-1.0248.98-4.4194-.0298-8.8379-.033-13.2567.0019-.8017.0063-1.09-.1567-1.0808-1.038.0647-6.5672.091-13.1375.0939-19.7052.0012-8.0822-.0149-16.1637-.0714-24.2455-.006-.8848.1792-1.1465 1.0932-1.1363 4.4194.0495 8.8383.0422 13.2571.0051.7957-.0073 1.0177.2321.9923 1.0063-.0549 1.6656-.0165 3.3335-.0165 5.3026z"></path>
                                                    <path d="m40.1241 71.1028c0 7.2826-.0155 14.5659.0187 21.8491.0038.9045-.1785 1.2264-1.1645 1.2134-4.377-.0584-8.7549-.0447-13.1324-.0079-.8129.0066-1.0869-.1963-1.086-1.0507.0213-14.6861.0178-29.3712-.0041-44.0569-.0009-.765.1856-1.0209.9882-1.0133 4.4579.038 8.9154.0428 13.3722-.0032.8896-.0098 1.0279.3149 1.0244 1.1008-.027 7.3235-.0152 14.6458-.0165 21.9687z"></path>
                                                    <path d="m32.5678 25.8388c5.8726.0064 9.6878 4.6579 8.2959 10.1135-1.0517 4.1194-5.3122 6.491-10.2299 5.6924-5.2234-.8477-8.1348-5.9452-6.21-10.8714 1.2013-3.0767 4.2757-4.9392 8.144-4.9345z"></path>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="linkedin_text1">openstudios</span>
                                    <span className="linkedin_text2">LinkedIn</span>
                                </button>

                                <button className="facebook_btn">
                                    <span className="facebook_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
                                            <g fillRule="evenodd" clipRule="evenodd">
                                                <path fill="#3a5ba2" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
                                                <path fill="#fff" d="m224.023 160.085c0-35.372 28.575-63.946 63.938-63.946h48.072v63.946h-32.199c-8.608 0-15.873 7.257-15.873 15.873v32.192h48.072v63.938h-48.072v144.22h-63.938v-144.22h-48.065v-63.938h48.065z"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="facebook_text1">openstudios</span>
                                    <span className="facebook_text2">Facebook</span>
                                </button>

                                <button className="whatsapp_btn">
                                    <span className="whatsapp_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="2em" viewBox="0 0 512 512" height="2em">
                                            <g fillRule="evenodd" clipRule="evenodd">
                                                <path fill="#25D366" d="m256.23 512c140.58 0 255.77-115.19 255.77-255.77 0-141.046-115.19-256.23-255.77-256.23-141.046 0-256.23 115.184-256.23 256.23 0 140.58 115.184 255.77 256.23 255.77z"></path>
                                                <path fill="#fff" transform="translate(80, 60) scale(0.75)" d="M391.84 322.51l-85.1-6.5a39.78 39.78 0 0 0-45.15 8.4l-32.91 33.06a317.26 317.26 0 0 1-137.64-137.5l33.13-32.85a39.78 39.78 0 0 0 8.47-45.16l-36.51-85.08a39.87 39.87 0 0 0-45.15-23.16L48.58 10.96a39.84 39.84 0 0 0-38.38 39.94c0 234.88 190.5 425.44 425.42 425.44a39.84 39.84 0 0 0 0 39.88 0 0 0-23.16-45.22z"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <span className="extraFont whatsapp_text1">+91 9876543210</span>
                                    <span className="whatsapp_text2">WhatsApp</span>
                                </button>
                            </div> */}
                    </div>
  );
};

export default FollowUs;
